import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { configApiClient, apiClient } from '../../utils/axiosAdvanced';
import { toast } from "react-toastify";
import { changeMapService, setGoogleAvailable } from "../map/mapSlice";

//TODO: this is dev apis. uncomment above block when running in production
const apiHosts = [
    'https://mobileapi.roadmatics.com:10004',
    'https://mobileapi02.roadmatics.com:10004',
];

const socketHosts = [
    'wss://sock01.roadmatics.com:10003',
    'wss://sock02.roadmatics.com:10003',
];

export const loginUser = createAsyncThunk(
    'user/loginUser',
    async ({ ilogusername, ilogpassword }, thunkAPI) => {
        try {
            //console.log(appStage())
            const {clientApp, authUrl} = appTypeDecider();
            const response = await axios.post(`${authUrl}/ilog_login_withclientapp`, { ilogusername, ilogpassword, clientApp });
            let data = response.data;
            if (clientApp.indexOf('local') != -1) {
                console.log('appType', clientApp, response.data);
            }

            if (response.status === 200) {
                if (data.error) {
                    thunkAPI.rejectWithValue(data.error);
                } else if (data.token && data.hosts) {
                    //console.log("login response", data);
                    configApiClient(data.token, data.hosts);
        
                    if (!data.keyError) {
                        //console.log("Google map available");
                        thunkAPI.dispatch(changeMapService('google'));
                        thunkAPI.dispatch(setGoogleAvailable(true));
                    } else {
                        thunkAPI.dispatch(changeMapService('osm'));
                        thunkAPI.dispatch(setGoogleAvailable(false));
                        console.log("Google map not available");
                    }
                } else {
                    thunkAPI.rejectWithValue(data);
                }
                //console.log("returning login response", data);
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (error) {
            thunkAPI.rejectWithValue(error.response.data);

        }
    }
);

export const searchUsername = createAsyncThunk(
    'user/searchUsername',
    async ({ searchUser }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/search_username', { searchUser });
            //console.log("USe ser api", apiData.data);
            let res = apiData.data.users;
            //console.log("res us", res);
            res.sort(function (a, b) {
                return parseInt(a.userid) - parseInt(b.userid);
            })
            return res;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const searchUserbyAsset = createAsyncThunk(
    'user/searchUserbyAsset',
    async ({ searchAsset }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/search_user_by_asset', { searchAsset });
            let res = apiData.data.users;
            //console.log("res ass", res);
            res.sort(function (a, b) {
                return parseInt(a.userid) - parseInt(b.userid);
            })
            return res;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const getUserAccess = createAsyncThunk(
    'user/getUserAccess',
    async ({ requestedUser }, thunkAPI) => {
        try {
            const {clientApp } = appTypeDecider();
            console.log("getUserAccess", requestedUser, clientApp);
            const apiData = await apiClient.post('/get_useraccess', { requestedUser, appType: appStage().appType, clientApp });
            const data = apiData.data;
            console.log("getUserAccess", data);
            if (apiData.status === 200) {
                if (data.error) {
                    thunkAPI.rejectWithValue(data.error);
                } else if (data.token && data.hosts) {
                    configApiClient(data.token, data.hosts);
                } else {
                    thunkAPI.rejectWithValue(data);
                }
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const getUserMapCreditData = createAsyncThunk(
    'user/getUserMapCreditData',
    async ({ mapUser }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/googlemap_read_credits', { mapUser });
            const data = apiData.data;
            return data.result;
        } catch (error) {
            //console.log("Get user map credit error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const updateUserMapCredits = createAsyncThunk(
    'user/updateUserMapCredits',
    async ({ dailyLimit, monthlyLimit, mapUser, keySource }, thunkAPI) => {
        try {
            //console.log("Cr upd api", dailyLimit, monthlyLimit, mapUser, keySource);
            const apiData = await apiClient.post('/googlemap_edit_usercredit', { dailyLimit, monthlyLimit, mapUser, keySource });
            const data = apiData.data;
            if (data.error) {
                toast.error(data.error);
            }
            if (data.result) {
                toast.info(data.result);
            }
        } catch (error) {
            //console.log("Get user map credit error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const addOwnGoogleKey = createAsyncThunk(
    'user/addOwnGoogleKey',
    async ({ ownKey, mapUser }, thunkAPI) => {
        try {
            //console.log("own key api", { ownKey, mapUser });
            const apiData = await apiClient.post('/googlemap_addkey', { ownKey, mapUser });
            const data = apiData.data;
            if (data.error) {
                toast.error(data.error);
            }
            if (data.result) {
                toast.info(data.result);
            }
        } catch (error) {
            //console.log("Get user map credit error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const adhocCredit = createAsyncThunk(
    'user/adhocCredit',
    async ({ mapUser, balanceQty }, thunkAPI) => {
        try {
            //console.log("adhoc credit api", { mapUser, balanceQty });
            const apiData = await apiClient.post('/googlemap_adhoc_balance', { mapUser, balanceQty });
            const data = apiData.data;
            if (data.error) {
                toast.error(data.error);
            }
            if (data.result) {
                toast.info(data.result);
            }
        } catch (error) {
            //console.log("Get user map credit error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const googleMapTransaction = createAsyncThunk(
    'user/googleMapTransaction',
    async ({ consumer, provider }, thunkAPI) => {
        try {
            await apiClient.post(`/googlemap_transaction`, { consumer, provider });
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

function appStage() {
    const isProduction = window.location.href.indexOf("v3.ilogistek.com") !== -1;
    const isBeta = window.location.href.indexOf("dev.dqw6ftwkytwa5.amplifyapp.com") !== -1;

    const ports = {
        production: 10001,
        beta: 10001,
        development: 10002,
    };

    let appType;
    if (isProduction) {
        appType = "production";
    } else if (isBeta) {
        //appType = "beta";
        appType = "development";
    } else {
        appType = "development";
    }
    console.log("AppStage", appType, ports[appType])
    return { appType, url: `https://mobileauth.roadmatics.com:${ports[appType]}` }
}


function appTypeDecider() {
    //const apiType = 'legacy';
    const apiType = 'modern';

    const betaAuth = 'https://mobileauth.roadmatics.com:10002';
    const prodAuth = 'https://mobileauth.roadmatics.com:10001';

    const isLegacy_v3 = window.location.href.indexOf("v3.ilogistek.com") !== -1;
    const isShiny = window.location.href.indexOf("shiny.ilogistek.com") !== -1;
    const isRoadrnext = window.location.href.indexOf("roadrnext.com") !== -1;
    const isLocalDev = window.location.href.indexOf("localhost") !== -1;

    //const isBeta = window.location.href.indexOf("dev.dqw6ftwkytwa5.amplifyapp.com") !== -1;

    let clientApp = 'roadrnext';
    let authUrl = prodAuth;

    if (isLegacy_v3) {
        clientApp = 'legacy_v3';
    } else if (isShiny) {
        clientApp = 'shiny';
    } else if (isLocalDev) {
        clientApp = `local_${apiType}`;
        authUrl = betaAuth;
    }
    return {clientApp, authUrl};
}